import React from 'react';
import './AboutUs.css';
import img1 from '../images/papaji-img.png'; // Ensure the image path is correct
import img2 from '../images/dilipimg.png'; // Ensure the image path is correct
import WhatsAppButton from '../modules/Whatsapp';

const AboutUs = () => {
  return (
    <section className="about-us" id='about1'>
      <div className="container">
        <h2 className="title">The Men Behind Waterproofing Excellence</h2>
        
        {/* Section for Dilip Kushwaha */}
        <div className="bio-section">
          <div className="bio-image">
            <img src={img2} alt="Dilip Kushwaha" width={300} height={300} className="person-image" />
          </div>
          <div className="bio-details">
            <h3>Er. Dilip Kushwaha</h3>
            <p>Dilip Kushwaha, an expert in waterproofing, has been learning the art and science of waterproofing since childhood from his father. He has hands-on experience working with different types of waterproofing techniques and is passionate about delivering high-quality, long-lasting solutions for his clients.</p>
          </div>
        </div>

        {/* Section for Father */}
        <div className="bio-section">
          <div className="bio-image">
            <img src={img1} alt="Father of Dilip Kushwaha" width={300} height={300} className="person-image" />
          </div>
          <div className="bio-details">
            <h3>Shankar Singh Kushwaha</h3>
            <p> Shankar Singh Kushwaha has over 23 years of experience in the waterproofing industry. His in-depth knowledge of waterproofing solutions has been passed down to his son, ensuring that the skills and expertise continue through generations. He has worked on numerous large-scale projects, consistently delivering excellent results.</p>
          </div>
        </div>

        {/* Call to Action Section */}
        <div className="cta">
          <p>Contact us to learn more about our waterproofing services, built on 23+ years of expertise!</p>
          <WhatsAppButton/>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
